//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import divSpan from '@/components/DivSpan';
export default {
  name: "assess-report",
  components:{
    divSpan
  },
  data(){
    return{
      wrapperHeight:0,
      allLoaded:false,
      configTodo:{
        title:'订单审批查询',
        url:'api/purOrderApprove/page',
        //tabList:['订单查询','待审批订单'],
        fixRules:{},
        inputCondition:{
          placeholder:'订单号/ERP订单号/需求跟踪号/供应商',
          searchCondition:'key',
          rules:[{field: "orderNo-supplier.supplierName-supplier.supplierCode-orderNoERP", option: "LIKE_ANYWHERE"}]
        },
      },
      rulesObj:{
        search:'',
        orderType:'',
        purOrg:'',
        itemStatus:''
      },
      pageRules:{
        direction: "DESC",
        fromClientType: "h5",
        number: 0,
        property: "createdDate",
        size:15,
        rules:[],
        specialConditions: [],
        ignoreField: true
      },

      list:[],
      show:true,
      orderStateList: [
        {name:'全部',code:null},
        {name:'草稿',code:'0'},
        {name:'审批中',code:'1'},
        {name:'审批完成',code:'2'}
      ],
    }
  },
  methods:{
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.getOrderList()
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    onCheckerClick(e){
      if(e){
        this.rulesObj.itemStatus={field: "purOrder.requestBase.currentNodeType",option:'IN',values:[e]}
      }else{
        delete this.rulesObj.itemStatus
      }
      this.getOrderList();
    },
    //获取全部订单
    getOrderList(){
      this.$loadingShow();
      this.pageRules.number = 0;
      this.pageRules.rules=Object.values(this.rulesObj).filter(val=>val.field && val.values[0])
      this.$post('api/purOrderApproveDt/page',this.pageRules).then((list) => {
        this.list = list.content;
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    goDetail(obj){
      this.$router.push('/workflow/'+(obj.purOrder.requestId)+'?component=ViewOrderDetailComponent');
    },
    goFlow(order){
      if(order.status !== '0' && order.status !== '6'){
        if(this.$store.state.device === 'wap'){
          this.$router.push('/workflow/'+(order.requestId || order.purOrder.requestId)+'?component=ViewOrderDetailComponent');
        }else{
          document.location = "http://action:10061/?url=" + appBaseUrl + "workflow/" + (order.requestId || order.purOrder.requestId) + "?device=" + this.$store.state.device + '&&hiddentitle=1 && component=ViewOrderDetailComponent';
        }
      }else {
        this.$router.push('/purchase-order-view/'+order.purOrder.id);
      }
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    getWorkFlow(){
      this.$get('api/biz-object-parameters/key/purOrderApprove').then(data=>{
        this.configTodo.workflowSearchBean = {
          workflowId: data.workflowType,
          searchType: '0'
        };
        this.$refs.header.getlist();
      })
    },
  },
  mounted(){
    this.init();
    this.getWorkFlow();
  }
}



// WEBPACK FOOTER //
// ./src/page/purchase-order/order-approve.vue